'use client';

export function getTrpcUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  return `${getApiUrl()}/trpc`;
}

/**
 * Returns the API base URL. For unauthenticated endpoints, we call the API
 * directly. If cookie-based auth is needed, uncomment the dev proxy below
 * and add corresponding rewrites in next.config.js.
 */
export function getApiUrl() {
  if (!process.env.NEXT_PUBLIC_API_URL) {
    throw new Error('NEXT_PUBLIC_API_URL is not defined');
  }

  // Dev proxy for cookie-based auth:
  // if (
  //   process.env.NODE_ENV === 'development' &&
  //   process.env.NEXT_PUBLIC_DEV === 'true'
  // ) {
  //   return '/api';
  // }

  return process.env.NEXT_PUBLIC_API_URL;
}
